import React from "react";
import taxiData from "./taxiData";

const Taxi = () => {
  return (
    <section className="section project" aria-labelledby="project-label">
      <div className="container">
        <p className="section-subtitle" id="project-label">
          Taxis
        </p>

        <h2
          className="h2 section-title"
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "gray",
          }}
        >
          Check out some of our awesome taxi services experiences with satisfied
          customers and seamless rides.
        </h2>

        <ul
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {taxiData.map((item) => (
            <li key={item.id}>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  border: "1px solid #e5e5e5",
                  overflow: "hidden",
                  width: "340px",
                  padding: "15px",
                }}
              >
                {/* Car Image */}
                <figure style={{ marginBottom: "15px" }}>
                  <img
                    src={item.image}
                    alt="Hyundai Venue"
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </figure>

                <div>
                  <h3
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                      color: "#333",
                    }}
                  >
                    {item.name}
                  </h3>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "15px",
                    }}
                  >
                    <div style={{ marginBottom: "8px" }}>
                      Driver: {item.driver}
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                      Rate sh. {item.price} per hour
                    </div>
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "2px solid #007BFF",
                        color: "#007BFF",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        flexGrow: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      {item.phone}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Taxi;
